import { UUID } from "crypto"
import { z } from "zod"

/**
 * @description
 *	The schema of {@link UUIDv4} type.
 */
export const UUIDv4Schema = z
	.uuid({ version: "v4" })
	.toLowerCase()
	.transform(uuid => uuid as UUID)

/**
 * @description
 *	A valid UUID v4 (variant RFC 4122).
 */
export type UUIDv4 = z.infer<typeof UUIDv4Schema>
